import { memo, useCallback } from "react";
import { Layout, Grid } from "antd";
import { useRouteMatch } from "react-router-dom";
import AppContent from "routes";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import NavigationBar from "./NavigationBar";
import NotificationDrawer from "./Notification/NotificationDrawer";
import styled from "styled-components";
import { NavigationBottomSelector } from "redux/selector/navigation-buttom-selector";
import { ErrorBoundary } from "react-error-boundary";
import { NavigatorHeight } from "const";
import { MenuSelector } from "redux/selector/menu-selector";
import debounce from "lodash/debounce";
import RedirectFallbackErrorPage from "routes/ErrorPage/RedirectFallbackErrorPage";
import { DeviceUtil } from "utils/device-util";
import { LoggingAPI } from "services/logging-server";
import { NotificationSelector } from "redux/selector/notification";
import MoneyConnectHeader from "./MoneyConnectHeader";
import { hideNotification, showNotification } from "redux/reducers/notification";

const { Content } = Layout;

const MainApp = () => {
  const dispatch = useDispatch();
  const screens = Grid.useBreakpoint();
  const match = useRouteMatch();
  const menuSet = useSelector(NavigationBottomSelector.navigationMenuSet);
  const forceHideAllMenu = useSelector(MenuSelector.forceHideAllMenu);
  const notificationVisible = useSelector(NotificationSelector.notificationVisible);

  useEffect(() => {
    // set innerHeight for css propose on mobile
    const getAppInnerHeight = debounce(() => {
      document.documentElement.style.setProperty("--app-height", `${window.innerHeight}px`);
    }, 400);
    getAppInnerHeight();
    window.addEventListener("resize", getAppInnerHeight);
    return () => window.removeEventListener("resize", getAppInnerHeight);
    // }
  }, [screens]);

  const setNotificationVisible = useCallback(
    (visible) => {
      if (visible) {
        dispatch(showNotification());
      } else {
        dispatch(hideNotification());
      }
    },
    [dispatch]
  );

  const onError = useCallback(async (error, errorInfo) => {
    if (error) {
      try {
        await LoggingAPI.error({
          message: JSON.stringify({
            error: {
              message: error.message,
              originError: error,
              errorInfo,
            },
            deviceInfo: DeviceUtil.getDeviceInfo(),
          }),
        });
      } catch (_) {}
    }
  }, []);

  return (
    <Layout className="app-container p-0 min-vh-100 min-vw-100">
      <MainLayout className="site-layout" $showNavigatorBottom={!!menuSet} $forceHideAllMenu={forceHideAllMenu}>
        <MoneyConnectHeader />
        <ErrorBoundary FallbackComponent={RedirectFallbackErrorPage} onError={onError}>
          <Content className="main-content position-relative">
            <AppContent match={match} />
          </Content>
          <NotificationDrawer isVisible={notificationVisible} setIsVisible={setNotificationVisible} />
          <NavigationBar menuSet={menuSet} forceHideAllMenu={forceHideAllMenu} />
        </ErrorBoundary>
      </MainLayout>
    </Layout>
  );
};

export default memo(MainApp);

const MainLayout = ({ children, ...props }) => <MainLayoutStyled {...props}>{children}</MainLayoutStyled>;

const MainLayoutStyled = styled(Layout)`
  overflow: hidden;

  main.main-content {
    padding-bottom: ${(props) => (props.$forceHideAllMenu ? 0 : NavigatorHeight)}px;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;
